var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[_c('section',{attrs:{"id":"intro"},domProps:{"innerHTML":_vm._s(_vm.home.text)}}),_c('info'),_c('programm'),_c('curators'),_c('press'),_c('partners'),_c('kontakt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }